import { useMutation } from "@apollo/client/react";
import {
  CreateArticleInKurssloeyfe,
  CreateArticleInKurssloeyfeVariables,
} from "__generated__/types";
import { CancelOrSubmit } from "common/buttons";
import { MutationLoadingOrError } from "common/components/forms/MutationLoadingOrError";
import { TextField } from "common/components/forms/TextField";
import gql from "graphql-tag";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";

const MUTATION = gql`
  mutation CreateArticleInKurssloeyfe(
    $input: CreateArticleInKurssloeyfeInput!
  ) {
    createArticleInKurssloeyfe(input: $input) {
      kurssloeyfeArticle {
        id
      }
    }
  }
`;

interface FormValues {
  title: string;
}

interface Props {
  kurssloeyfeId: string;
  cancel(): void;
  complete(): void;
}

//TODO: See if this component and CreateFolderArticleForm can be refactored into one component
export const KurssloeyfeArticleCreateForm: React.FC<
  React.PropsWithChildren<Props>
> = ({ kurssloeyfeId, cancel, complete }) => {
  const methods = useForm<FormValues>();

  const [mutate, { loading, error }] = useMutation<
    CreateArticleInKurssloeyfe,
    CreateArticleInKurssloeyfeVariables
  >(MUTATION);

  const onSubmit = async (data: FormValues) => {
    const result = await mutate({
      variables: {
        input: {
          kurssloeyfeId,
          article: {
            title: data.title,
          },
        },
      },
    });

    if (result.data) {
      complete();
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <TextField
          title="Tittel"
          fieldProps={methods.register("title", {
            required: "Du må fylle inn dette feltet",
          })}
        />

        <MutationLoadingOrError loading={loading} error={error} />

        <CancelOrSubmit onCancel={cancel} isLoading={loading} />
      </form>
    </FormProvider>
  );
};
